module.exports = __webpack_public_path__ + "img/razor.edcb158a.webp";